import React from 'react'
import '../styles/why-us.scss'
import sideImg from '../assets/model-side-pic.png'

import CustomButton from './Custom-Button'

const WhyUs = () => (

    <div className="why-us">
        <div className="left-side">
            <div className="side-image">
                <img src={sideImg} />
            </div>
            <div className="back-image">
                <img src={sideImg} />
            </div>
        </div>
        <div className="right-side">
            <h1>Why Our Clients Choose Us</h1>
            <div className="divider"></div>
            <h2>Our salon strives to provide the best experience in nail design and outstanding customer service.</h2>
            <h3>We use the highest quality of products and have a large selection of high end brands and colors.</h3>
            <h3 className="red-text">There's a reason why we're one of the most top rated nail salon in Summerville.</h3>
            <CustomButton />
        </div>
    </div>
)

export default WhyUs